// BASE_URL に /api/v1 が含まれるため、相対パスは /tenants/... から始まる
// （例: getWarehousesEndpoint='/berths/load_warehouses' / createShipmentEndpoint='/shipments'）
export const getTenantShipmentsEndpoint = (tenantId: number): string =>
  `/tenants/${tenantId}/shipments`
